var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'icon-button-wrapper': true,
  'icon-button-wrapper--selected': _vm.selected
  },on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"icon"},[_vm._t("default")],2),(_vm.title)?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }